import React from "react";
import PropTypes from "prop-types";

function SectionHeading({ heading, mb = "mb-16p mb-7p md-fs", dailogId, ...rest }) {
    return (
        <div {...rest}>
            <h2 id={dailogId} className={"section-heading " + mb}>{heading}</h2>
        </div>
    );
}

SectionHeading.propTypes = {
    heading: PropTypes.string,
    mb: PropTypes.string,
    dailogId: PropTypes.string
}

export default SectionHeading;
